import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isMaskClosable = false, onClose, children } = this.props;
    return (
      <div className="v3-modal-mask" onClick={isMaskClosable && onClose}>
        <div className="v3-modal">{children}</div>
      </div>
    );
  }
}

Modal.propTypes = {
  isMaskClosable: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default Modal;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Modal/index.js
 **/